import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Form, Spinner, Table, Badge } from "react-bootstrap";
import blogFetch from "../../axios/config";
import toast from "react-hot-toast";
import { Ciclo, Peca, Valvulas } from "./Types";
import { Laptop, Lock } from "@mui/icons-material";
import ModalAcompanhamentoACV from "./ModalAcompanhamentoACV";
import ModalControleValvulasFechadas from "./ModalControleValvulasFechadas";

export const TabelaApontametosACV = ({ atualizarSignal }: { atualizarSignal?: number }) => {

  const [ciclos, setCiclos] = useState<Ciclo[]>([]);
  const [pecasPorCiclo, setPecasPorCiclo] = useState<Record<number, Peca[]>>({});
  const [contagemPecas, setContagemPecas] = useState<Record<number, number>>({});
  const [contagemSets, setContagemSets] = useState<Record<number, number>>({});
  const [loadingCiclos, setLoadingCiclos] = useState<boolean>(false);
  const [loadingPecas, setLoadingPecas] = useState<boolean>(false);

  const [peca, setPeca] = useState<Peca>({
    ordem: "",
    posicao: "",
    piso: null,
    tipoPeca: "",
    codigoVeiculo: "",
    projeto: "",
    veiculo: "",
    matricula: "",
    ordem_CC_RetMin: 0
  });


  const [cicloSelecionado, setCicloSelecionado] = useState<number | null>(null);
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [modal, setModal] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const [showConfirmApontamento, setShowConfirmApontamento] = useState(false);
  const [cicloParaApontar, setCicloParaApontar] = useState<Ciclo | null>(null);
  const [loadingApontamento, setLoadingApontamento] = useState(false);

  const [modalChecklistACV, setModalChecklistACV] = useState(false);
  const [showEditAutoclave, setShowEditAutoclave] = useState(false);
  const [editingCiclo, setEditingCiclo] = useState<Ciclo | null>(null);
  const [editingCyclo, setEditingCyclo] = useState<string>("");
  const [editingAutoclave, setEditingAutoclave] = useState<string>("");
  const [editingCarro, setEditingCarro] = useState<string>("");
  const [loadingEditAutoclave, setLoadingEditAutoclave] = useState(false);
  const [cicloSelecionando, setCicloSelecionando] = useState<Ciclo | null>(null)

  const [valvulasFechadas, setValvulasFechadas] = useState<Valvulas[]>([]);
  const [cicloValvulas, setCicloValvulas] = useState(null);
  const [showModalListaValvulas, setShowModalListaValvulas] = useState(false);
  const [showModalCriarValvula, setShowModalCriarValvula] = useState(false);


  const carrosPorAutoclave: Record<string, string[]> = {
    Chicago: ["Chicago - 1", "Chicago - 2", "Chicago - 3"],
    "Matriz Molde": ["Matriz - 1", "Matriz - 2"],
    Ferlex: ["Ferlex - 1", "Ferlex - 2"],
    Fhaizer: ["Fhaizer - 1", "Fhaizer - 2"],
  };

  const carrosDisponiveis = carrosPorAutoclave[editingAutoclave] || [];

  // Função para calcular a quantidade de sets
  const calcularQuantidadeSets = (ordem_CC_RetMin: number): number => {
    return ordem_CC_RetMin / 4.5;
  };

  // Função para calcular total de sets de um ciclo
  const calcularTotalSets = (pecas: Peca[]): number => {
    return pecas.reduce((total, peca) => {
      return total + calcularQuantidadeSets(peca.ordem_CC_RetMin || 0);
    }, 0);
  };


  const handelOpenACVCloseModalCheckList = async (cicloSelecionando: number) => {

    const ciclo = ciclos.find(c => c.ciclo_key === cicloSelecionando) || null;
    setCicloSelecionando(ciclo);
    setModalChecklistACV(true);
  }

  const abrirEditarAutoclave = (ciclo: Ciclo) => {
    setEditingCiclo(ciclo);
    setEditingCyclo(ciclo.ciclo ?? "");
    setEditingAutoclave(ciclo.autoclave ?? "");
    setEditingCarro(ciclo.carro ?? "");
    setShowEditAutoclave(true);
  };


  // Salvar alteração da autoclave
  const salvarAutoclave = async () => {

    if (!editingCiclo) return;
    setLoadingEditAutoclave(true);

    try {
      await blogFetch.put("ApontamentoAutoClave/updateAutoclave", {
        ciclo_key: editingCiclo.ciclo_key,
        ciclo: editingCyclo,
        autoclave: editingAutoclave,
        carro: editingCarro,
      });
      toast.success("Autoclave atualizada com sucesso!");
      setShowEditAutoclave(false);
      setEditingCiclo(null);
      carregarCiclos();
    } catch (error: any) {
      console.error("Erro ao atualizar autoclave:", error);
      toast.error(error.response?.data || "Erro ao atualizar autoclave.");
    } finally {
      setLoadingEditAutoclave(false);
    }
  };

  // ---------- Fetch Ciclos ----------
  const carregarCiclos = async () => {
    setLoadingCiclos(true);
    try {
      const { data } = await blogFetch.get("ApontamentoAutoClave/GetCiclos");
      if (Array.isArray(data)) {
        setCiclos(data);
        // Carregar contagem de peças para cada ciclo
        carregarContagemTodasPecas(data);
      } else {
        setCiclos([]);
        console.warn("Dados de ciclos inválidos:", data);
      }
    } catch (error: any) {
      console.error("Erro ao carregar ciclos:", error);
      toast.error(error.response?.data || "Erro ao carregar ciclos.");
      setCiclos([]);
    } finally {
      setLoadingCiclos(false);
    }
  };

  // Carregar contagem de peças para todos os ciclos
  const carregarContagemTodasPecas = async (ciclosData: Ciclo[]) => {
    const novaContagem: Record<number, number> = {};
    const novaContagemSets: Record<number, number> = {};

    for (const ciclo of ciclosData) {
      try {
        const { data } = await blogFetch.get(`ApontamentoAutoClave/getPecasByCiclo/${ciclo.ciclo_key}`);
        if (Array.isArray(data)) {
          novaContagem[ciclo.ciclo_key] = data.length;
          novaContagemSets[ciclo.ciclo_key] = calcularTotalSets(data);
        } else {
          novaContagem[ciclo.ciclo_key] = 0;
          novaContagemSets[ciclo.ciclo_key] = 0;
        }
      } catch (error) {
        novaContagem[ciclo.ciclo_key] = 0;
        novaContagemSets[ciclo.ciclo_key] = 0;
      }
    }

    setContagemPecas(novaContagem);
    setContagemSets(novaContagemSets);
  };

  useEffect(() => {
    carregarCiclos();
  }, [atualizarSignal]);

  // ---------- Buscar Peça ----------
  useEffect(() => {
    if (!modal || !peca.ordem?.trim()) return;
    const timeout = setTimeout(() => buscarPeca(peca.ordem), 800);
    return () => clearTimeout(timeout);
  }, [peca.ordem, modal]);

  const buscarPeca = async (ordem: string) => {
    try {
      const { data } = await blogFetch.get(`ApontamentoAutoClave/getPeca/${ordem}`);
      if (!data) {
        toast.error("Peça não encontrada.");
        return;
      }
      setPeca((prev) => ({
        ...prev,
        codigoVeiculo: data.ordem_VehCod || "",
        projeto: data.subProduto_Desc || "",
        tipoPeca: data.ordem_Part_Short || "",
        veiculo: data.ordem_VehDesc || "",
        ordem_CC_RetMin: data.ordem_CC_RetMin || 0
      }));
    } catch (error: any) {
      console.error("Erro ao buscar peça:", error);
      toast.error(error.response?.data || "Erro ao buscar peça.");
    }
  };

  // ---------- Peças por ciclo ----------
  const carregarPecasDoCiclo = async (cicloKey: number) => {
    setLoadingPecas(true);
    try {
      const { data } = await blogFetch.get(`ApontamentoAutoClave/getPecasByCiclo/${cicloKey}`);
      if (Array.isArray(data)) {
        setPecasPorCiclo((prev) => ({ ...prev, [cicloKey]: data }));
        setContagemPecas((prev) => ({ ...prev, [cicloKey]: data.length }));
        setContagemSets((prev) => ({ ...prev, [cicloKey]: calcularTotalSets(data) }));
      } else {
        setPecasPorCiclo((prev) => ({ ...prev, [cicloKey]: [] }));
        setContagemPecas((prev) => ({ ...prev, [cicloKey]: 0 }));
        setContagemSets((prev) => ({ ...prev, [cicloKey]: 0 }));
      }
    } catch (error: any) {
      console.error("Erro ao buscar peças do ciclo:", error);
      toast.error(error.response?.data || "Erro ao buscar peças do ciclo.");
    } finally {
      setLoadingPecas(false);
    }
  };


  const adicionarPeca = async () => {
    if (!cicloSelecionado) {
      toast.error("Selecione um ciclo.");
      return;
    }
    if (!peca.ordem.trim() || !peca.posicao.trim()) {
      toast.error("Preencha todos os campos obrigatórios.");
      return;
    }

    try {
      const payload = {
        ordem: peca.ordem.trim(),
        posicao: peca.posicao,
        piso: peca.piso?.toString(),
        ciclo: cicloSelecionado,
        tipoPeca: peca.tipoPeca,
        codigoVeiculo: peca.codigoVeiculo,
        projeto: peca.projeto,
        veiculo: peca.veiculo,
        matricula: peca.matricula || null,
        ordem_CC_RetMin: peca.ordem_CC_RetMin || null,
      };

      await blogFetch.post("ApontamentoAutoClave/addPeca", payload);
      toast.success("Peça adicionada com sucesso!");
      await carregarPecasDoCiclo(cicloSelecionado);
      resetarPeca();

      setTimeout(() => {
        inputRef.current?.focus();
      }, 50);
    } catch (error: any) {
      console.error("Erro ao adicionar peça:", error);
      toast.error(error.response?.data || "Erro ao retirar peça.");
    }
  };


  const handleACVCloseModalCheckList = () => {
    setModalChecklistACV(false);
  };

  const handleRetiraPeca = async (ordem: string) => {
    if (!ordem) {
      toast.error("Algo deu errado. Ordem da peça não encontrada.");
      return;
    }

    try {
      await blogFetch.delete(`ApontamentoAutoClave/removePeca/${ordem}`);

      toast.success("Peça retirada com sucesso!");

      if (expandedRow) {
        await carregarPecasDoCiclo(expandedRow);
      }

    } catch (error: any) {
      console.error("Erro ao retirar peça:", error);
      toast.error(error.response?.data || "Erro ao retirar peça.");
    }
  };

  const RemoverCiclo = async (cicloKey: number) => {
    if (!cicloKey) {
      toast.error("Algo deu errado. Ciclo não encontrado.");
      return;
    }

    try {
      await blogFetch.delete(`ApontamentoAutoClave/removeCiclo/${cicloKey}`);
      toast.success("Ciclo excluído com sucesso!");
      carregarCiclos();
    } catch (error: any) {
      console.error("Erro ao excluir ciclo:", error);
      toast.error(error.response?.data || "Erro ao excluir ciclo.");
    }
  };

  const abrirListaValvulas = (e: any, ciclo: any) => {
    e.stopPropagation(); // evita abrir/fechar linha

    setCicloValvulas(ciclo);
    setShowModalListaValvulas(true);

    carregarValvulas(ciclo.ciclo_isaga);
  };


  const carregarValvulas = async (cicloKey: string | undefined) => {
    try {

      setValvulasFechadas([]);

      const resp = await blogFetch.get(`/ISAGA_ValvulasFechadas/listar_valvulas/${cicloKey}`);

      // garante que o loading não está sobrescrevendo o estado 
      setValvulasFechadas(resp.data || []);
    } catch (error) {
      console.log(error);
      toast.error("Erro ao carregar válvulas fechadas!");
    }
  };
  const handleConfirmApontamento = async () => {
    if (!cicloParaApontar) return;
    setLoadingApontamento(true);
    try {

      await blogFetch.put("ApontamentoAutoClave/apontarCiclo", {

        ciclo: cicloParaApontar.ciclo_isaga,
        user: user.user_UserName,
      });

      toast.success("Apontamento realizado com sucesso!");
      setShowConfirmApontamento(false);
      carregarCiclos();
    } catch (error: any) {
      console.error(error);
      toast.error(error.response?.data || "Erro ao apontar ciclo.");
    } finally {
      setLoadingApontamento(false);
    }
  };

  const resetarPeca = () => {
    setPeca({
      ordem: "",
      posicao: "",
      piso: null,
      tipoPeca: "",
      codigoVeiculo: "",
      projeto: "",
      veiculo: "",
      matricula: "",
      ordem_CC_RetMin: 0
    });
  };

  console.log(peca);

  useEffect(() => {
    if (modal) {


      const timer = setTimeout(() => {
        inputRef.current?.focus();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [modal]);

  const fecharModal = () => {
    setModal(false);
    setCicloSelecionado(null);
    resetarPeca();
  };

  const toggleRow = async (id: number) => {
    if (expandedRow === id) {
      setExpandedRow(null);
      return;
    }
    setExpandedRow(id);
    await carregarPecasDoCiclo(id);
  };

  // ---------- JSX ----------
  return (
    <div className="card shadow-sm border-0 rounded-lg">
      <div className="card-header d-flex justify-content-between align-items-center py-3 px-4 rounded-top">
        <h2 className="card-title h6 mb-0 fw-bold">📋 Lista de Ciclos</h2>
        <Button size="sm" variant="light" onClick={carregarCiclos} className="fw-bold px-3">
          Atualizar
        </Button>
      </div>

      <div className="card-body p-0" style={{ maxHeight: "500px", overflowY: "auto" }}>
        {loadingCiclos ? (
          <div className="text-center py-5">
            <Spinner animation="border" size="sm" className="text-primary mb-2" />
            <p className="text-muted mt-2">Carregando ciclos...</p>
          </div>
        ) : ciclos.length === 0 ? (
          <div className="text-center py-5">
            <p className="text-muted">📭 Nenhum ciclo encontrado.</p>
          </div>
        ) : (
          <div className="d-flex justify-content-center">
            <table className="table table-hover table-sm mb-0 table-fixed align-middle text-center">
              <thead className="bg-light border-bottom">
                <tr>
                  <th className="fw-bold ">Ciclo-ISaga</th>
                  <th className="fw-bold ">Ciclo-Sap</th>
                  <th className="fw-bold text-center">CheckAutoClave</th>
                  <th className="fw-bold text-center">Controle Valvulas</th>
                  <th className="fw-bold ">Auto-Clave</th>
                  <th className="fw-bold ">Carro</th>
                  <th className="fw-bold ">Tipo</th>
                  <th className="fw-bold text-center">Status</th>
                  <th className="fw-bold text-center">Qtd Peças</th>
                  <th className="fw-bold text-center">Qtd Sets</th>
                  <th className="fw-bold ">Entrada</th>
                  <th className="fw-bold ">Entrada por</th>
                  <th className="fw-bold ">Saída</th>
                  <th className="fw-bold ">Saída por</th>
                  <th className="fw-bold text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {ciclos.map((ciclo) => (
                  <React.Fragment key={ciclo.ciclo_key}>
                    <tr onClick={() => toggleRow(ciclo.ciclo_key)} style={{ cursor: "pointer" }}>
                      <td>{ciclo.ciclo_isaga}</td>
                      <td>{ciclo.ciclo_sap === 0 ? "—" : ciclo.ciclo_sap}</td>
                      <td>
                        <button
                          className="btn btn-info btn-md"
                          disabled={ciclo.status?.toLowerCase().includes("aguardando entrada")}
                          onClick={() => handelOpenACVCloseModalCheckList(ciclo.ciclo_key)}>
                          <Laptop fontSize="small" />
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn btn-info btn-md"
                          disabled={ciclo.status?.toLowerCase().includes("aguardando entrada")}
                          onClick={(e) => {
                            abrirListaValvulas(e, ciclo);
                          }}
                        >
                          <Lock fontSize="small" />
                        </button>

                      </td>
                      <td>{ciclo.autoclave}</td>
                      <td>{ciclo.carro}</td>
                      <td>{ciclo.ciclo}</td>
                      <td
                        className={`text-center text-white fw-bold
                          ${ciclo.status?.toLowerCase().includes("aguardando entrada")
                            ? "bg-warning text-dark"
                            : ciclo.status?.toLowerCase().includes("em ciclo")
                              ? "bg-primary"
                              : ciclo.status?.toLowerCase().includes("saida")
                                ? "bg-success"
                                : ""}`}
                      >
                        {ciclo.status}
                      </td>
                      <td className="text-center">
                        <Badge bg={contagemPecas[ciclo.ciclo_key] > 0 ? "primary" : "secondary"} pill>
                          {contagemPecas[ciclo.ciclo_key] || 0}
                        </Badge>
                      </td>
                      <td className="text-center">
                        <Badge bg={contagemSets[ciclo.ciclo_key] > 0 ? "success" : "secondary"} pill>
                          {(contagemSets[ciclo.ciclo_key] || 0).toFixed(2)}
                        </Badge>
                      </td>
                      <td>{ciclo.entrada ? new Date(ciclo.entrada).toLocaleString() : "—"}</td>
                      <td>{ciclo.entradaPor}</td>
                      <td>{ciclo.saida ? new Date(ciclo.saida).toLocaleString() : "—"}</td>
                      <td>{ciclo.saidaPor}</td>
                      <td>
                        <div className="d-flex gap-2 justify-content-center">
                          {ciclo.status?.toLowerCase().includes("aguardando entrada") && (
                            <>
                              <Button
                                size="sm"
                                variant="warning"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCicloParaApontar(ciclo);
                                  setShowConfirmApontamento(true);
                                }}
                              >
                                Apontar Ciclo
                              </Button>

                              <Button
                                size="sm"
                                variant="primary"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCicloSelecionado(ciclo.ciclo_key);
                                  setModal(true);
                                }}
                              >
                                Adicionar Peça
                              </Button>

                              <Button
                                size="sm"
                                variant="secondary"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  abrirEditarAutoclave(ciclo);
                                }}
                              >
                                Editar Autoclave
                              </Button>

                              <Button
                                size="sm"
                                variant="danger"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  RemoverCiclo(ciclo.ciclo_key);
                                }}
                              >
                                Excluir Ciclo
                              </Button>
                            </>
                          )}

                          {ciclo.status?.toLowerCase().includes("em ciclo") && (
                            <Button
                              size="sm"
                              variant="warning"
                              onClick={(e) => {
                                e.stopPropagation();
                                setCicloParaApontar(ciclo);
                                setShowConfirmApontamento(true);
                              }}
                            >
                              Apontar Ciclo
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>

                    {expandedRow === ciclo.ciclo_key && (
                      <tr>
                        <td colSpan={15}>
                          <div className="p-2 bg-light border rounded justify-center align-center">
                            <h6 className="fw-bold">
                              Peças
                              <Badge bg="primary" className="ms-2" pill>
                                {contagemPecas[ciclo.ciclo_key] || 0}
                              </Badge>
                              <Badge bg="success" className="ms-2" pill>
                                {(contagemSets[ciclo.ciclo_key] || 0).toFixed(2)} sets
                              </Badge>
                            </h6>

                            {loadingPecas ? (
                              <div className="text-center py-2">
                                <Spinner animation="border" size="sm" /> Carregando...
                              </div>
                            ) : (
                              <table className="table table-sm table-fixed w-100 text-center align-middle mb-0">
                                <thead>
                                  <tr>
                                    <th>Ordem</th>
                                    <th>Posição</th>
                                    <th>Piso</th>
                                    <th>Tipo Peça</th>
                                    <th>Código Veículo</th>
                                    <th>Projeto</th>
                                    <th>Veículo</th>
                                    <th>Qtd Sets</th>
                                    <th>Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {pecasPorCiclo[ciclo.ciclo_key]?.length ? (
                                    pecasPorCiclo[ciclo.ciclo_key].map((p, i) => (
                                      <tr key={i}>
                                        <td>{p.ordem}</td>
                                        <td>{p.posicao}</td>
                                        <td>{p.piso ?? "—"}</td>
                                        <td>{p.tipoPeca}</td>
                                        <td>{p.codigoVeiculo}</td>
                                        <td>{p.projeto}</td>
                                        <td>{p.veiculo}</td>
                                        <td>
                                          <Badge bg="info" pill>
                                            {calcularQuantidadeSets(p.ordem_CC_RetMin || 0).toFixed(5)}
                                          </Badge>
                                        </td>
                                        {ciclo.status?.toLowerCase().includes("aguardando entrada") && (<td>

                                          <Button
                                            size="sm"
                                            variant="danger"
                                            onClick={(e) => handleRetiraPeca(p.ordem)}
                                          >
                                            Retirar Peça
                                          </Button>
                                        </td>)}

                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={9} className="text-center text-muted">
                                        Nenhuma peça encontrada.
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>



      <Modal show={modalChecklistACV} size="xl" onHide={() => handleACVCloseModalCheckList()} centered>

        <Modal.Body>
          <ModalAcompanhamentoACV
            cicloSelecionando={cicloSelecionando}
            onClose={() => handleACVCloseModalCheckList()} />
        </Modal.Body>

      </Modal>

      <Modal
        show={showModalListaValvulas}
        onHide={() => setShowModalListaValvulas(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Perda de Vacuo</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {valvulasFechadas.length === 0 ? (
            <p>Nenhuma válvula cadastrada.</p>
          ) : (
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Ciclo</th>
                  <th>Autoclave</th>
                  <th>Linha</th>
                  <th>Válvula</th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                {valvulasFechadas.map((v) => (
                  <tr key={v.valvulasFechadas_key}>
                    <td>{v.valvulasFechadas_ciclo}</td>
                    <td>{v.valvulasFechadas_autoclave}</td>
                    <td>{v.valvulasFechadas_linha}</td>
                    <td>{v.valvulasFechadas_valvula}</td>
                    <td>{new Date(v._ts_Creat).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalListaValvulas(false)}>
            Fechar
          </Button>

          <Button
            variant="primary"
            onClick={() => setShowModalCriarValvula(true)}
          >
            Fechar Válvula
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalControleValvulasFechadas
        show={showModalCriarValvula}
        onHide={() => {
          setShowModalCriarValvula(false);
          carregarValvulas(cicloSelecionando?.ciclo_isaga);
        }}
        ciclo={cicloValvulas}
      />





      <Modal show={showEditAutoclave} onHide={() => setShowEditAutoclave(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Autoclave - Ciclo {editingCiclo?.ciclo_isaga}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={(e) => { e.preventDefault(); salvarAutoclave(); }}>
            <Form.Group className="mb-3">
              <Form.Label>Ciclo</Form.Label>
              <select
                className="form-select border-primary"
                value={editingCyclo}
                onChange={(e) => setEditingCyclo(e.target.value)}
                required
              >
                <option value="">Escolha o ciclo</option>
                <option value="CICLO PCHT N3">CICLO PCHT N3</option>
                <option value="CICLO PCHT IB33">CICLO PCHT IB33</option>
                <option value="CICLO AL NV7 NIMR">CICLO AL NV7 NIMR</option>
                <option value="CICLO KAROTEK PET">CICLO KAROTEK PET</option>
                <option value="CICLO KAROTEK NORTHGLASS">CICLO KAROTEK NORTHGLASS</option>
                <option value="CICLO PCHT N5 AGPB">CICLO PCHT N5 AGPB</option>
                <option value="CICLO AL NV5 COM AÇO">CICLO AL NV5 COM AÇO</option>
                <option value="CICLO NV8 PCHT AGPB">CICLO NV8 PCHT AGPB</option>
              </select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Autoclave</Form.Label>
              <Form.Select
                value={editingAutoclave}
                onChange={(e) => {
                  setEditingAutoclave(e.target.value);
                  setEditingCarro("");
                }}
              >
                <option value="">Selecione</option>
                <option value="Chicago">Chicago</option>
                <option value="Matriz Molde">Matriz Molde</option>
                <option value="Ferlex">Ferlex</option>
                <option value="Fhaizer">Fhaizer</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Carro</Form.Label>
              <Form.Select
                value={editingCarro}
                onChange={(e) => setEditingCarro(e.target.value)}
                disabled={!editingAutoclave}
              >
                <option value="">Selecione</option>
                {carrosDisponiveis.map((c) => (
                  <option key={c} value={c}>{c}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => setShowEditAutoclave(false)}>
            Cancelar
          </Button>
          <Button variant="primary" size="sm" onClick={salvarAutoclave} disabled={loadingEditAutoclave}>
            {loadingEditAutoclave ? <Spinner animation="border" size="sm" /> : "Salvar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODAL PRINCIPAL */}
      <Modal show={modal} onHide={fecharModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Apontamento da Peça</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="card p-3 shadow-sm rounded-3 mb-3">
            <h6 className="fw-bold text-secondary mb-3">Adicionar Peça ao Ciclo</h6>
            <Form onSubmit={(e) => e.preventDefault()}>
              <Form.Group className="mb-3">
                <Form.Label>Ordem</Form.Label>
                <Form.Control
                  type="text"
                  value={peca.ordem}
                  ref={inputRef}
                  onChange={(e) => setPeca((p) => ({ ...p, ordem: e.target.value }))}
                  placeholder="Digite a ordem da peça"
                />
              </Form.Group>

              <Form.Group className="mb-1">
                <div className="row g-3 align-items-start">
                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-semibold">Posição</label>
                    <div className="d-flex gap-2 flex-wrap mt-1">
                      {["Fundo", "Centro", "Porta"].map((pos) => (
                        <Button
                          key={pos}
                          variant={peca.posicao === pos.toLowerCase() ? "primary" : "outline-primary"}
                          size="sm"
                          className="px-3"
                          onClick={(e) => {
                            e.preventDefault();
                            setPeca((p) => ({ ...p, posicao: pos.toLowerCase() }));
                          }}
                        >
                          {pos}
                        </Button>
                      ))}
                    </div>
                  </div>

                  <div className="col-12 col-md-6">
                    <label className="form-label small fw-semibold">Piso</label>
                    <div className="d-flex gap-2 flex-wrap mt-1">
                      {Array.from({ length: 8 }, (_, i) => i + 1).map((n) => (
                        <Button
                          key={n}
                          variant={peca.piso === n ? "primary" : "outline-primary"}
                          size="sm"
                          className="px-2"
                          onClick={(e) => {
                            e.preventDefault();
                            setPeca((p) => ({ ...p, piso: n }));
                          }}
                        >
                          {n}
                        </Button>
                      ))}
                    </div>
                  </div>
                </div>
              </Form.Group>
              <Form.Group className="mt-3">
                <Form.Label>Matricula</Form.Label>
                <Form.Control
                  type="text"
                  value={peca.matricula || ""}
                  onChange={(e) => setPeca((p) => ({ ...p, matricula: e.target.value }))}
                  placeholder="Digite a matrícula do Operador"
                />
              </Form.Group>
            </Form>
          </div>

          <div className="card p-3 shadow-sm rounded-3">
            <h6 className="fw-bold text-secondary mb-3">Informações do Veículo</h6>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label small fw-semibold text-muted">Tipo Peça</label>
                <input value={peca.tipoPeca} className="form-control" readOnly />
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-semibold text-muted">Código Veículo</label>
                <input value={peca.codigoVeiculo} className="form-control" readOnly />
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-semibold text-muted">Projeto</label>
                <input value={peca.projeto} className="form-control" readOnly />
              </div>
              <div className="col-md-6">
                <label className="form-label small fw-semibold text-muted">Qtd Sets</label>
                <input value={calcularQuantidadeSets(peca.ordem_CC_RetMin).toFixed(2)} className="form-control" readOnly />
              </div>
              <div className="col-12">
                <label className="form-label small fw-semibold text-muted">Veículo</label>
                <input value={peca.veiculo} className="form-control" readOnly />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={fecharModal}>
            Cancelar
          </Button>
          <Button variant="primary" size="sm" onClick={adicionarPeca} >
            Adicionar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* MODAL DE CONFIRMAÇÃO DE APONTAMENTO */}
      <Modal show={showConfirmApontamento} onHide={() => setShowConfirmApontamento(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Apontamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Tem certeza que deseja apontar o ciclo{" "}
          <strong>{cicloParaApontar?.ciclo_isaga}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={() => setShowConfirmApontamento(false)}>
            Cancelar
          </Button>
          <Button variant="warning" size="sm" onClick={handleConfirmApontamento} disabled={loadingApontamento}>
            {loadingApontamento ? <Spinner animation="border" size="sm" /> : "Confirmar"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};